/** @module Classes */ /** typedoc */

export class ModelStateError {
    code: string;
    message: string;
    field: string;

    static fromMonolith(input: any = {}) {
        let newModelStateError = new ModelStateError();

        newModelStateError.code = input.errorCode;
        newModelStateError.message = input.errorMessage;
        newModelStateError.field = input.field;

        return newModelStateError;
    }
}
